module.exports = __webpack_public_path__ + "img/3-image2.86da5b68.png";